/**
 * Gives focus back to the control that opened a popover or dialog. Browsers that follow the
 * "script focus is keyboard focus" rule (Firefox, Safari) would draw the keyboard ring around the
 * control (and its whole card) after a purely MOUSE interaction; so the ring is requested only when
 * the last input was the keyboard. Chromium decides this itself and ignores the option.
 */
let keyboard = false;

if (typeof document !== 'undefined') {
  document.addEventListener(
    'keydown',
    (event) => {
      if (!event.metaKey && !event.ctrlKey && !event.altKey) keyboard = true;
    },
    true,
  );
  document.addEventListener(
    'pointerdown',
    () => {
      keyboard = false;
    },
    true,
  );
}

export function restoreFocus(element: HTMLElement): void {
  const options: FocusOptions & { focusVisible?: boolean } = { preventScroll: true };
  if (!keyboard) options.focusVisible = false;
  element.focus(options);
}
